import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-point';

const adjustMemberPoints = (merchantId, customerid, data) => {
	return Client.post(
		`${baseUrl}/${merchantId}/points-activities/${customerid}`,
		data
	);
};

const pointActivities = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/point-activities`, data);
};

const pointBalance = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/point-accounts`, data);
};

const measurements = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/measurements`, data);
};

const exchanges = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/exchanges`, data);
};

const addMeasurements = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/measurements`, data);
};

const updateMeasurements = (merchantId, data, measurementId) => {
	return Client.put(
		`${baseUrl}/${merchantId}/measurements/${measurementId}`,
		data
	);
};

const pointActivitiesExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/point-activities/export`, data, {
		responseType: 'blob',
	});
};

export default {
	adjustMemberPoints,
	pointActivities,
	pointBalance,
	measurements,
	exchanges,
	addMeasurements,
	updateMeasurements,
	pointActivitiesExport,
};
